import React, { useState, useEffect } from 'react'
import { useAuth } from './../Context/AuthContext'
import AccessDenied from './Common/AccessDenied'
import { useLocation } from 'react-router-dom'

const PermissionCheck = ({ requiredRoles, children }) => {
    const { userInfo, isAuthenticated } = useAuth()
    const [hasAccess, setHasAccess] = useState(null)
    const location = useLocation()

    useEffect(() => {
        if (userInfo && isAuthenticated) {
            const hasRequiredRole = requiredRoles.some((role) => userInfo.roles.includes(role))
            setHasAccess(hasRequiredRole)
        }
    }, [userInfo, isAuthenticated, requiredRoles, location])

    if (hasAccess === null) {
        return <div>Loading...</div>
    }
    if (!hasAccess) {
        return <AccessDenied />
    }

    return children
}

export default PermissionCheck
